import { UserAgent, Inviter, SessionState } from "sip.js";

const CALL_HOLD_ACTIONS = {
    HOLD: 'hold',
    UNHOLD: 'unhold'
} 

export const onAcceptInvitation = async(invitation, acceptInvitation, end, cleanupMedia)=>{
    try{
        await invitation.accept();
        acceptInvitation(invitation);
        invitation.stateChange.addListener((state) => {
            switch (state) {
              case 'Terminated':
                cleanupMedia();
                end();
                break;
              default:
                console.log("Unknown session state.");
            }
          });
    }catch (error) {
        console.log('Error to accept invitation', error);
    }
}

export const onRejectInvitation = async(invitation, reject, cleanupMedia)=>{
    try{
        await invitation.reject();
        reject();
        cleanupMedia();
    }catch (error) {
        console.log('Error to reject invitation', error);
    }
}

export const handleCallHoldState = async(session, shouldHold = true) => {
    try {
        if (!session?.data) {
            throw new Error('No active session provided');
        }

        const action = shouldHold ? CALL_HOLD_ACTIONS.HOLD : CALL_HOLD_ACTIONS.UNHOLD;          

        const options = {
            sessionDescriptionHandlerOptions: {
                hold: shouldHold,
                constraints: {
                    audio: true,
                    video: false,
                },
            },
        };

        await session.data.invite(options); 
    } catch (error) {
        console.error(`Error while trying to ${shouldHold ? CALL_HOLD_ACTIONS.HOLD : CALL_HOLD_ACTIONS.UNHOLD} call:`, error);
        throw error;
    }
};

export const onHoldInvitation = (session) => handleCallHoldState(session, true);

export const onUnHoldInvitation = (session) => handleCallHoldState(session, false);


export const handleAttendedTransfer = async (currentSession, transferTarget, domain) => {
    try {
        
        const target = UserAgent.makeURI(`sip:${transferTarget}@${domain}`);
        if (!target) {
            throw new Error("Invalid transfer target");
        }

        return new Promise((resolve, reject) => {
            currentSession.data.refer(target, {
                requestDelegate: {
                    onAccept: () => {                        
                        currentSession.data.bye().then(() => {
                            resolve();
                        }).catch(error => {
                            console.error('Error terminando la sesión:', error);
                            resolve();
                        });
                    },
                    onReject: () => {
                        reject(new Error("Transfer rejected"));
                    }
                }
            });
        });
    } catch (error) {
        console.error('Error en transferencia atendida:', error);
        throw error;
    }
};